import Axios, { AxiosPromise } from 'axios';
import { getAuth0Domain } from '../../../config/ConfigService';
import { ResetPasswordResponse } from '../../components/pages/set-your-password/ResetPasswordResponse';

const resetPassword = (
  password: string,
  csrfToken: string,
  ticketId: string,
): AxiosPromise<ResetPasswordResponse> => {
  const data = new URLSearchParams();
  data.append('newPassword', password);
  data.append('confirmNewPassword', password);
  data.append('ticket', ticketId);
  data.append('_csrf', csrfToken);

  return Axios.post<ResetPasswordResponse>('https://' + getAuth0Domain() + '/lo/reset', data);
};

export { resetPassword };
